import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap';
import renderHTML from 'react-render-html';
import config from 'react-global-configuration';
import PropTypes from 'prop-types';

import { BlackHeading } from './BlackboardStyle'
import { Black, LogeButtonSlim } from '../../GeneralStyle'
import BlogPostEditor from './BlogPostEditor'


import { inject, PropTypes as MobxPropTypes } from 'mobx-react'

@inject('blogStore', 'userStore')
class BlogPost extends Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false
    }
    this.deleteBlogPost = this.deleteBlogPost.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
  }

  deleteBlogPost() {
    this.props.blogStore.deleteBlogPost(this.props.objectId)
  }

  highlightBlogPost() {
    this.props.blogStore.highlightBlogPost(this.props.objectId)
  }

  editBlogPost() {
    this.setState({ edit: true })
  }

  cancelEdit() {
    this.setState({ edit: false })
  }

  render() {
    let { userRole } = this.props.userStore

    let editButton = (
      <LogeButtonSlim
        hoverFontColor={"white"}
        onClick={() => { this.editBlogPost() }}>
        Beitrag bearbeiten</LogeButtonSlim>
    )

    let highlightButton = (
      this.props.isHighlighted
        ?
        <LogeButtonSlim
          style={{ backgroundColor: 'rgb(217, 83, 79)', border: "none" }}
          hoverFontColor={"white"}
          fontColor={"white"}
          onClick={() => { this.highlightBlogPost() }}>
          Hervorhebung revidieren</LogeButtonSlim>
        :
        <LogeButtonSlim
          hoverFontColor={"white"}
          onClick={() => { this.highlightBlogPost() }}>
          Beitrag hervorheben</LogeButtonSlim>
    )

    return (
      <div className={'blog-post'}>
        {this.state.edit
          ? <BlogPostEditor
            editPost={true}
            blogPost={{
              imageId: this.props.imageId,
              text: this.props.text,
              title: this.props.title,
              objectId: this.props.objectId
            }}
            cancelEdit={this.cancelEdit} />
          : <Row className={'row-eq-height-resp'}>
            <Col sm={12} md={3}>
              <div style={{ height: '100%' }}>
                <img style={{ maxWidth: '100%', marginTop: 10 }} role="presentation" src={`${config.get('CLOUDINARY_URL')}${((this.props.imageId === "") || (this.props.imageId === null)) ? "wappen_text_zrwh0q" : this.props.imageId}.jpg`} />
                <Black style={{ fontWeight: 100, paddingTop: 25 }}>Beitrag erstellt, am {' '} {new Date(this.props.createdAt).toLocaleDateString("de-DE")}</Black>
              </div>
            </Col>
            <Col sm={12} md={9} className={'blog-content'}>
              <BlackHeading>{this.props.title}</BlackHeading>
              <Black>
                {renderHTML(this.props.text)}
              </Black>
            </Col>
            <div style={{ float: "right", margin: 10 }}>
              {((userRole === "admin") || (userRole === "theLoge")) ? editButton : null}
              {((userRole === "admin") || (userRole === "theLoge")) ? highlightButton : null}
            </div>
          </Row>
        }

      </div>
    )
  }
}

BlogPost.propTypes = {
  title: PropTypes.string,
  imageId: PropTypes.string,
  createdAt: PropTypes.string,
  text: PropTypes.string,
  objectId: PropTypes.string,
  blogStore: MobxPropTypes.observableObject,
  userStore: MobxPropTypes.observableObject,
  isHighlighted: PropTypes.bool,
  edit: PropTypes.bool
}

export default BlogPost;



// WEBPACK FOOTER //
// /src/components/internal/BlackboardBlog/BlogPost.js